import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppStateFacade } from '@app-state';
import {
    IQueueItemEvent,
    ODataResponse,
} from '@models';
import { ODataQueryOptions } from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const NAMESPACE = 'UiPath.Server.Configuration.OData';
@Injectable()
export class QueueItemEventService extends ODataService<IQueueItemEvent, number> {
    protected _endpoint: string;
    constructor(
        http: HttpClient,
        { authConfig }: AppStateFacade,
    ) {
        super(http, MapperService.queueItemEventMap);
        this._endpoint = `${authConfig.odataBaseUrl}/QueueItemEvents`;
    }

    public getByItem(queueItemId: number, queryOptions?: ODataQueryOptions) {
        return this._http.get(
            `${this._endpoint}/${NAMESPACE}.GetQueueItemEventsHistory(queueItemId=${queueItemId})${this.getQueryString(queryOptions)}`,
        ).pipe(
            map(response => this._mapData(response)),
        ) as Observable<ODataResponse<any>>;
    }
}
